import React from 'react';
import HeroSection from '../components/HeroSection';
import FeaturesBar from '../sections/FeaturesBar';
import NewArrivals from '../sections/NewArrivals';
import Collections from '../sections/Collections';
import OfferBanner from '../sections/OfferBanner';
import Bestsellers from '../sections/Bestsellers';
import ShopByReel from '../sections/ShopByReel';
import AamiraLuxe from '../sections/AamiraLuxe';
import FAQSection from '../sections/FAQSection';
import JewelleryGallery from '../sections/JewelleryGallery';
import AamiraReviews from '../sections/AamiraReviews';
import Collections1 from '../sections/collections1'; 
import FourCollections from '../sections/FourCollections';   


const Home = () => {
  return (
    <>
      <HeroSection />
      <FeaturesBar />
      <NewArrivals />
      <Collections />
     
      <Bestsellers />
      <OfferBanner />
      <ShopByReel />
      <Collections1 />
      <AamiraReviews />
      <FourCollections />
      <AamiraLuxe />
      
      
      <FAQSection />
      <JewelleryGallery />
      

      {/* More sections will be added here */}
    </>
  );
};

export default Home;